import React from 'react';
import moment from 'moment';

export const getColumns = (children) => {
  let columns = [];

  children.forEach((child, i) => {
    columns = getColumn(child, columns);
  });

  return columns;
};

const getColumn = (child, columns) => {
  switch (child.type.colType) {
    case 'Column':
      columns.push({
        ...child.props,
      });
      break;
    case 'Date':
      columns.push({
        ...child.props,
        headerClass: 'width-1 text-center',
        cellClassName: 'text-nowrap text-center',
        render: (value) => {
          return <span>{value && moment(value).format('DD-MM-YYYY')}</span>;
        },
      });
      break;
    default:
      break;
  }

  return columns;
};
